import { LoadingOutlined, UploadOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Modal, Row, Typography, Upload } from "antd";
import Arrow from 'assets/svg/arrow.svg';
import ivrPending from "assets/svg/ivrPending.svg";
import SaudiRiyal from "assets/svg/saudi_riyal_symbol.svg";
import SheriCard from "assets/svg/sheriCard.svg";
import SheriZeroCard from "assets/svg/sherizeroCard.svg";
import axios from "axios";
import { FormDrawer, buildInitialValues, buildValidationSchema } from 'Components';
import { useTranslation } from "contexts/TranslationContext";
import { Formik } from "formik";
import useAuthHook from "hooks/useAuthHook";
import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { useCreateNewAppMutation, useCreateNewTawaruqAppMutation, useCreateNewMurabahaAppMutation, useUpdateAppDetailsMutation, useUpdateAppDetailsV2Mutation } from "services/auth";
import BackButton from 'shared/components/BackButton/BackButton';
import env from "shared/constants/env";
import routes, { appRoute } from 'shared/constants/routes';
import * as Yup from "yup";
import SalaryEligibilityGate from "components/SalaryEligibility/SalaryEligibilityGate";

// import SilverVoucher from "assets/svg/SilverVoucher.svg";
// import EmeraldVoucher from "assets/svg/EmeraldVoucher.svg";



const { Title, Text } = Typography;
const { Dragger } = Upload;



const Vouchers = () => {
    const { translate, language } = useTranslation();
    const navigate = useNavigate();
    // Redirect to home with coming soon message
    useEffect(() => {
        if (id == '1') {
            toast.info(translate("VOUCHERS.COMING_SOON_MSG") || "This service is coming soon!");
            navigate(`/${routes.APP_ROOT}/${routes.HOME}`, { replace: true });
        }
    }, [navigate, translate]);

    // V1 Mutations (kept for backwards compatibility)
    const [createNewApp, createNewAppStatus] = useCreateNewAppMutation();
    const [updateApplicationDetails, updateAppDetailsStatus] = useUpdateAppDetailsMutation();
    // V2 Mutations (active)
    const [createNewTawaruqApp, createNewTawaruqAppStatus] = useCreateNewTawaruqAppMutation();
    const [createNewMurabahaApp, createNewMurabahaAppStatus] = useCreateNewMurabahaAppMutation();
    const [updateApplicationDetailsV2, updateAppDetailsStatusV2] = useUpdateAppDetailsV2Mutation();
    const { getUser } = useAuthHook();
    const { id } = useParams()
    const [uploadFile, setUploadFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [isUploading, setIsUploading] = useState(false)

    // V2 Document selection tracking (before app creation)
    const [selectedBankStatement, setSelectedBankStatement] = useState(null);
    const [selectedPaySlip, setSelectedPaySlip] = useState(null);
    const [selectedOtherDocuments, setSelectedOtherDocuments] = useState(null);

    // V2 Individual file upload loading states (during upload phase)
    const [bankStatementUploading, setBankStatementUploading] = useState(false);
    const [paySlipUploading, setPaySlipUploading] = useState(false);
    const [otherDocumentsUploading, setOtherDocumentsUploading] = useState(false);

    const [tenureOptions, setTenureOptions] = useState([]);
    const [termsChecked, setTermsChecked] = useState(true);
    const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);
    const [isCreating, setIsCreating] = useState(false);
    const [isIvrModalVisible, setIsIvrModalVisible] = useState(false);
    const [ivrApplicationId, setIvrApplicationId] = useState(null);
    const formikRef = useRef(null);

    const jsxCompatibleHtmlString = `
<p>تم إعداد هذه الشروط والأحكام بهدف توضيح الإرشادات وتحديد الشروط القانونية الملزمة المتعلقة بخدمة تقسيط المشتريات، التي تقدمها شركة تمويل الأولى، وهي شركة تأسست وفقاً للأنظمة والقوانين المعمول بها في المملكة العربية السعودية (ويُشار إليها فيما بعد بـ &quot;تمويل الأولى&quot;).</p>
<p><strong>يُطلب منك الاطلاع على هذه الشروط والأحكام والموافقة عليها قبل منحك حق الدخول واستكمال عملية التسجيل من قبل الشركة.</strong><br />تستلزم عملية التسجيل قيام شركة &quot;تمويل الأولى&quot; بإجراء فحوصات &quot;اعرف عميلك&quot; (KYC)، وذلك بهدف التحقق من هويتك كمستخدم مخوّل للاستفادة من الخدمات المقدمة.<br />وسيتم تنفيذ هذا الإجراء فقط بعد قيامك بالموافقة على هذه الشروط والأحكام بشكل صريح.</p>
<p>🔔 <strong>ملاحظة هامة لجميع عملائنا:</strong></p>
<p>يُشار إلى الطرف الثاني في هذه الوثيقة بـ <strong>&quot;العميل&quot;</strong>، بصفته مقترضاً.<br />تخضع جميع المنتجات والخدمات المالية المقدّمة من شركة <strong>تمويل الأولى</strong> إلى الشروط والأحكام المبيّنة في هذه الوثيقة (ويُشار إليها لاحقاً بـ <strong>&quot;الشروط والأحكام&quot;</strong>).</p>
<p>بموجب تقديمك لطلب الخدمة، سيتم اعتبارك عميلاً لدى الشركة. ويُعد استخدامك للموقع الرقمي بمثابة موافقة صريحة على الالتزام بجميع الشروط والأحكام المنشورة على هذه الصفحة.<br />لذا، <strong>نحثّك على قراءة هذه الشروط بعناية تامة</strong>، لما لها من أثر مباشر على حقوقك والتزاماتك بموجب القوانين المعمول بها في المملكة العربية السعودية.</p>
<p>وفي حال وجود أي جزء غير واضح أو إذا كنت بحاجة لتفسير أي من البنود، <strong>نوصيك بالتواصل مع ممثلي خدمة العملاء</strong> لمساعدتك وتقديم الإيضاحات اللازمة.</p>
<p>❗️<strong>إذا كنت لا توافق على هذه الشروط والأحكام، نرجو الامتناع عن استخدام خدمة تقسيط المشتريات أو التسجيل في تطبيق تمويل الأولى.</strong></p>
<p><strong>يُرجى العلم بأن هذه الشروط والأحكام قابلة للتحديث أو التعديل في أي وقت، وذلك دون الحاجة إلى إشعار مسبق.</strong><br />كما يخضع الموقع الرقمي بكامله، بما في ذلك جميع الخدمات والمحتويات المقدمة من خلاله، لأنظمة وقوانين المملكة العربية السعودية.</p>
<p><strong>الملكية الفكرية والاستخدام والمسؤوليات القانونية</strong></p>
<ul>
<li>لا يجوز للمستخدم نسخ أو تخزين أي جزء من هذا الموقع الرقمي، <strong>إلا لأغراض شخصية بحتة</strong>، وفي هذه الحالة يتوجب عليه الاحتفاظ بجميع إشعارات حقوق النشر والعلامات المبيّنة في الصفحات الأصلية.&nbsp; </li>
<li>تُعد جميع العلامات والشعارات المعروضة ضمن الموقع <strong>ملكية خاصة بشركة تمويل الأولى</strong>، ويُمنع منعًا باتًا نسخها أو استخدامها بأي شكل من الأشكال دون <strong>إذن كتابي مسبق</strong> من الشركة.&nbsp; </li>
<li>تسعى &quot;تمويل الأولى&quot; للحفاظ على استمرارية عمل الموقع الرقمي <strong>طوال الوقت وعلى مدار الساعة</strong>، إلا أنها <strong>لا تتحمل أي مسؤولية</strong> في حال تعرّض الموقع لأي توقف مؤقت أو دائم لأي سبب كان، ودون الحاجة إلى إشعار مسبق.&nbsp; </li>
<li>تبذل &quot;تمويل الأولى&quot; أقصى جهودها لضمان <strong>صحة ودقة</strong> المعلومات المعروضة عبر الموقع، لكنها <strong>لا تضمن</strong> أن تكون هذه المعلومات <strong>حديثة أو مكتملة في جميع الأوقات</strong>، ويتم عرض كافة المحتويات <strong>&quot;كما هي&quot; دون أي ضمانات</strong> صريحة أو ضمنية من أي نوع.&nbsp; </li>
<li><p>جميع الحقوق محفوظة لشركة <strong>تمويل الأولى</strong>، بما في ذلك حقوق النشر المتعلقة بتصميم الصفحات، وطريقة عرض المحتوى، والمعلومات المضمّنة في الموقع، <strong>ما لم يُذكر خلاف ذلك</strong>.&nbsp; </p>
</li>
<li><p><strong>حدود المسؤولية:</strong> لا تتحمل &quot;تمويل الأولى&quot; بأي حال من الأحوال أي مسؤولية عن <strong>أي أضرار أو خسائر</strong>، سواء كانت مباشرة أو غير مباشرة أو عرضية أو ناتجة عن استخدام الموقع أو عدم التمكن من استخدامه، بما في ذلك (دون حصر):</p>
</li>
<li><p>تأخير في التشغيل أو الإرسال&nbsp; </p>
</li>
<li>فشل في الاتصال أو النظام&nbsp; </li>
<li>الإصابة بالفيروسات&nbsp; </li>
<li><p>أو أي قصور تقني، حتى في حال تم إشعار الشركة أو ممثليها بإمكانية حدوث ذلك.</p>
</li>
<li><p>جميع الحقوق محفوظة لشركة <strong>تمويل الأولى</strong>، بما في ذلك حقوق النشر المتعلقة بتصميم الصفحات، وطريقة عرض المحتوى، والمعلومات المضمّنة في الموقع، <strong>ما لم يُذكر خلاف ذلك</strong>.</p>
</li>
</ul>
<h3 id="-"><strong>التعريفات</strong></h3>
<p><strong>لأغراض هذه الوثيقة، يكون للكلمات والعبارات التالية المعاني الموضحة أمام كلٍ منها، ما لم يقتضِ السياق خلاف ذلك:</strong></p>
<ul>
<li><strong>&quot;الموقع الرقمي&quot;</strong> يُقصد به تطبيق الهاتف المحمول الخاص بشركة تمويل الأولى، والذي يتم تحميله وتثبيته على الهواتف الذكية أو الأجهزة اللوحية، ويُستخدم كمنصة رقمية للاستفادة من خدمات ومنتجات الشركة.&nbsp; </li>
<li><strong>&quot;سمة&quot;</strong> تشير إلى الشركة السعودية للمعلومات الائتمانية.&nbsp; </li>
<li><strong>&quot;ساما&quot;</strong> تعني البنك المركزي السعودي.&nbsp; </li>
<li><strong>&quot;الوكيل/الوسيط&quot;</strong> هو الشخص أو الكيان الذي يتم تحديده من قبل &quot;تمويل الأولى&quot; ليعمل كحلقة وصل بين طرفين أو أكثر بهدف تحقيق غاية محددة أو إتمام صفقة.&nbsp; </li>
<li><strong>&quot;خدمات الوكيل/الوسيط&quot;</strong> تُشير إلى الوظائف والخدمات المقدمة من قبل الوكيل أو الوسيط، وذلك وفقًا لنطاق عمله وتخصصه.&nbsp; </li>
<li><strong>&quot;العميل&quot;</strong> هو الشخص أو الكيان الذي يقوم بشراء أو استخدام منتجات أو خدمات &quot;تمويل الأولى&quot;، ويشمل ذلك البيانات الشخصية ومعلومات &quot;اعرف عميلك&quot; التي تم التحقق منها بناءً على متطلبات البنك المركزي السعودي والجهات الحكومية الأخرى.&nbsp; </li>
<li><strong>&quot;تمويل&quot;</strong> يُشير إلى منتجات التمويل المقدّمة من قبل &quot;تمويل الأولى&quot;، ويخضع قرار أهلية الحصول على هذه المنتجات للتقدير المطلق للشركة، وبما يتوافق مع معايير وإجراءات التأهيل الخاصة بها.&nbsp; </li>
<li><strong>&quot;رمز التفعيل&quot;</strong> رقم سري مكوّن من 4 أرقام يُرسل للعميل عند التسجيل في تطبيق &quot;تمويل الأولى&quot;، ويُستخدم لتفعيل حسابه.&nbsp; </li>
<li><strong>&quot;غسل الأموال&quot;</strong> يُقصد به جميع الأنشطة المحظورة بموجب الأنظمة واللوائح المتعلقة بمكافحة غسل الأموال المعتمدة في المملكة العربية السعودية.&nbsp; </li>
<li><strong>&quot;شركة تمويل الأولى&quot;</strong> شركة مساهمة مقفلة، مسجلة وفقًا لأنظمة المملكة العربية السعودية، ويقع مقرها الرئيسي في مدينة الدمام.</li>
</ul>
<h3 id="-"><strong>المتطلبات والتسجيل</strong></h3>
<ul>
<li>يمكن للعميل إتمام عملية التسجيل من خلال تطبيق &quot;تمويل الأولى&quot;.&nbsp; </li>
<li>يخضع التسجيل في خدمات تطبيق &quot;تمويل الأولى&quot; لإجراءات جمع معلومات <strong>&quot;اعرف عميلك&quot;</strong> (KYC) والتحقق من الهوية، وذلك وفقًا للأنظمة والتعليمات الصادرة عن <strong>البنك المركزي السعودي</strong>.&nbsp; </li>
<li>تحتفظ شركة &quot;تمويل الأولى&quot; بالحق الكامل في أي وقت لاتخاذ كافة الخطوات والإجراءات اللازمة لضمان <strong>الامتثال التام</strong> لمتطلبات &quot;اعرف عميلك&quot; المعتمدة لدى الجهات المختصة، بما في ذلك البنك المركزي السعودي.&nbsp; </li>
<li>يُقر العميل ويشهد بأن <strong>جميع المعلومات والبيانات المقدّمة منه صحيحة وكاملة ودقيقة</strong>، ويتحمل وحده مسؤولية أي معلومات مضللة أو ناقصة.&nbsp; </li>
<li>تحتفظ &quot;تمويل الأولى&quot; بالحق في <strong>رفض أي طلب تسجيل</strong> في حال وجود أي تناقض أو عدم دقة في المعلومات أو المستندات المقدّمة من العميل، دون الحاجة إلى تقديم مبررات.&nbsp; </li>
<li>عند إتمام عملية التسجيل، <strong>يتلقى العميل &quot;رمز التفعيل&quot;</strong> – وهو رقم سري مكوّن من 4 أرقام – ويُطلب منه إدخاله في التطبيق لتفعيل الحساب.&nbsp; </li>
<li>بعد إدخال رمز التفعيل بنجاح، <strong>سيتلقى العميل رسالة تأكيد فورية</strong> تفيد بإتمام إنشاء الحساب وتفعيله بنجاح.</li>
</ul>
<h3 id="-"><strong>الأمن والاستخدام غير المصرح به</strong></h3>
<ul>
<li>يتحمل <strong>العميل وحده</strong> المسؤولية الكاملة عن <strong>سرية وسلامة وأمان</strong> اسم المستخدم وكلمة المرور الخاصة بحسابه على الموقع الرقمي.&nbsp; </li>
<li>يُعد العميل مسؤولًا عن <strong>أي استخدام غير مصرح به</strong> لحسابه، وعن جميع النتائج والعواقب التي قد تنشأ عن هذا الاستخدام.&nbsp; </li>
<li>في حال فقدان أو تعطل الخدمة أو في حال وجود <strong>اختراق أمني بأي شكل من الأشكال</strong>، يجب على العميل إبلاغ شركة &quot;تمويل الأولى&quot; <strong>فورًا</strong>، وذلك من خلال الاتصال على الرقم الموحد أو عبر البريد الإلكتروني التالي:<br />📧 <strong>info@Tamweel-aloula.com</strong>&nbsp; </li>
<li>ستقوم الشركة، بعد التحقق من الحالة، بـ <strong>حظر الحساب مؤقتًا</strong> وإصدار <strong>بيانات اعتماد جديدة</strong> للعميل لضمان استمرارية الأمان.&nbsp; </li>
<li>تقع على عاتق العميل مسؤولية الحفاظ على سرية اسم المستخدم، كلمة المرور، وأي رموز أو أكواد دخول أخرى يتم توفيرها له من قبل &quot;تمويل الأولى&quot;.&nbsp; </li>
<li>يُمنع منعًا باتًا على العميل <strong>الإفصاح عن تفاصيل حسابه أو سجلاته لأي شخص آخر</strong>، بما في ذلك موظفي خدمة العملاء أو مركز العناية بالعملاء.</li>
</ul>
<p><strong>معلومات العميل وتحديثها</strong></p>
<ul>
<li>يُقر العميل بأن جميع المعلومات والمستندات التي تم تقديمها لغرض الحصول على التمويل هي <strong>صحيحة وسارية ونظامية</strong> في وقت التقديم.&nbsp; </li>
<li>يتوجب على العميل <strong>إبلاغ شركة تمويل الأولى فورًا</strong> بأي تغييرات تطرأ على بياناته الشخصية، مثل – على سبيل المثال لا الحصر: تغيير الاسم – تغيير العنوان الوطني – تغيير جهة او مكان العمل .&nbsp; &nbsp;</li>
<li>يتحمّل العميل وحده <strong>المسؤولية الكاملة</strong> عن دقة المعلومات المُدخلة في تطبيق &quot;تمويل الأولى&quot;، وفي حال تبيّن أن أي من المعلومات كانت <strong>غير صحيحة أو خاطئة أو مضللة</strong>، فإن &quot;تمويل الأولى&quot; <strong>لا تتحمّل أي مسؤولية أو التزام قانوني</strong> عن العواقب التي قد تترتب على ذلك.&nbsp; </li>
<li>في حال علم العميل بشكل فعلي أو استنتاجي بوجود <strong>خطأ أو عدم دقة</strong> في البيانات الخاصة بحسابه، يتوجب عليه التواصل مع الشركة <strong>عبر الرقم الموحد [920005477] او البريد الالكتروني [info@Tamweel-aloula.com]</strong>&nbsp; &nbsp;</li>
<li>في حال عدم قيام العميل بإبلاغ الشركة بأي تغيير في معلوماته الشخصية أو المالية، <strong>لا يؤثر ذلك على حق &quot;تمويل الأولى&quot;</strong> في المطالبة بجميع المبالغ المستحقة أو الالتزامات المترتبة بموجب عقد التمويل، باستخدام البيانات المتوفرة لديها في حينه.&nbsp; </li>
<li>تحتفظ &quot;تمويل الأولى&quot; بالحق الكامل في <strong>إنهاء حساب العميل</strong> في حال ثَبُت أن المعلومات المقدمة كانت خاطئة أو مضللة، ويجوز تنفيذ ذلك <strong>في أي وقت، مع أو بدون إشعار مسبق</strong>.&nbsp; </li>
<li>يسري قرار الإنهاء فور صدوره من &quot;تمويل الأولى&quot;، أو في التاريخ المحدد ضمن الإشعار الصادر عنها، ويشمل الإنهاء <strong>تعطيل وصول العميل إلى الموقع الرقمي</strong> وجميع الخدمات المرتبطة به.</li>
</ul>
<p><strong>حماية البيانات والسرية</strong></p>
<p>تُعامل جميع المعلومات المتعلقة بالعميل على أنها <strong>سرية وخاصة</strong>، ما لم تكن هذه المعلومات متاحة بالفعل <strong>في النطاق العام</strong>.</p>
<p>لا يجوز الكشف عن معلومات العميل لأي طرف ثالث، <strong>باستثناء</strong> الحالات الموضحة أدناه، حيث تحتفظ &quot;تمويل الأولى&quot; بحقها في الإفصاح عن المعلومات أو الوثائق ذات الصلة بالعميل إلى:</p>
<ol>
<li>فروع &quot;تمويل الأولى&quot;، وشركتها القابضة، والشركات التابعة، والممثلين، والوكلاء المعتمدين.&nbsp; </li>
<li>وكالات التحقق الائتماني وإعداد التقارير المالية.&nbsp; </li>
<li>وكالات تحصيل الديون العاملة فيما يتعلق بالحسابات أو المبالغ المستحقة على العميل.&nbsp; </li>
<li>المحامين، مدققي الحسابات، والمستشارين الفنيين أو الاستشاريين العاملين مع الشركة، لأغراض تحليل البيانات، وتقييم المخاطر، وتقديم الاستشارات أو إدارة علاقات العملاء، أو لأغراض العمل المعتادة.&nbsp; </li>
<li>أي جهة قضائية، أو تنظيمية، أو شرطية، أو حكومية مختصة في المملكة العربية السعودية.&nbsp; </li>
<li>أي طرف ثالث يتم التعاقد معه لتقديم خدمات أو أداء وظائف نيابة عن &quot;تمويل الأولى&quot;، بشرط الحصول على <strong>تعهدات سرية مناسبة</strong> حسب ما تقرره الشركة.</li>
</ol>
<p>تحتفظ &quot;تمويل الأولى&quot; <strong>بالصلاحية الكاملة</strong> في جميع الأوقات لجمع المعلومات المتعلقة بالعميل من أطراف ثالثة، مثل مكاتب الائتمان، البنوك، الجهات الحكومية ذات العلاقة، شركاء البيع بالتجزئة، و<strong>البنك المركزي السعودي</strong>.</p>
<p>تخضع خصوصية الاتصالات الإلكترونية <strong>للتعليمات الصادرة من البنك المركزي السعودي</strong>، بما في ذلك قراراته وتعاميمه ذات الصلة.</p>
<p>يقر العميل بموافقته على أنه، ولتسهيل تقديم خدمات &quot;تمويل الأولى&quot;، قد يُطلب من الشركة الإفصاح عن معلوماته لأي جهة حكومية، سواءً كان ذلك بموجب الأنظمة أو بموافقته الكتابية المسبقة.</p>
<p><strong>لا يحق لأي شخص غير مصرح له</strong> الوصول إلى المعلومات الشخصية أو المالية الخاصة بالعميل، وتقتصر صلاحية الاطلاع عليها على <strong>الموظفين المعتمدين فقط</strong>.</p>
<p>تلتزم &quot;تمويل الأولى&quot; باتخاذ <strong>كافة التدابير المعقولة والمتاحة</strong> لضمان أن تظل معلومات العملاء ومعاملاتهم محمية وآمنة وسرية في جميع الأوقات.</p>
<p><strong>التزامات العميل</strong></p>
<p>• يتحمّل العميل <strong>المسؤولية الكاملة</strong> عن جميع الرسوم والمصاريف المترتبة على تسهيلات التمويل المقدّمة له من قبل &quot;تمويل الأولى&quot;.<br />• يُمنع على العميل استخدام خدمات &quot;تمويل الأولى&quot; لأي غرض يُمكن تفسيره على أنه:</p>
<ul>
<li>مخالف لأي من <strong>الأنظمة والقوانين المعمول بها</strong> في المملكة العربية السعودية،&nbsp; </li>
<li>أو غير متوافق مع <strong>تعليمات البنك المركزي السعودي</strong> أو لوائحه التنظيمية،&nbsp; </li>
<li>أو يتعارض مع <strong>البيانات القضائية أو السياسات العامة</strong>،&nbsp; </li>
<li>أو مخالف لسياسات &quot;تمويل الأولى&quot; الداخلية،&nbsp; </li>
<li>أو يترتب عليه <strong>إساءة مباشرة أو غير مباشرة</strong> للسمعة التجارية لـ &quot;تمويل الأولى&quot;.</li>
</ul>
<p><strong>إخلاء المسؤولية والتعويض</strong></p>
<p>• دون الإخلال بأي من الأحكام الواردة في هذه الوثيقة، لا تقدم <strong>&quot;تمويل الأولى&quot;</strong> أي ضمانات صريحة أو ضمنية بخصوص <strong>المنتجات أو الخدمات المقدّمة</strong> بموجب هذه الشروط والأحكام، بما في ذلك – على سبيل المثال لا الحصر – أي ضمانات تتعلق بـ:</p>
<ul>
<li>جودة المنتج&nbsp; </li>
<li>عدم انتهاك حقوق أطراف ثالثة&nbsp; </li>
<li>قابلية التسويق&nbsp; </li>
<li>الملاءمة لغرض معين&nbsp; </li>
<li>الرضا العام عن الخدمة أو المنتج</li>
</ul>
<p>لا تقدم &quot;تمويل الأولى&quot; أي ضمان أو تعهد صريح أو ضمني يتعلق <strong>بخدماتها</strong> المذكورة في هذه الوثيقة، كما لا تضمن توفر أو استمرارية تلك الخدمات في جميع الأوقات.</p>
<p><strong>&quot;تمويل الأولى&quot; غير مسؤولة</strong> عن أي أفعال أو تقصير من قبل أي <strong>طرف ثالث</strong>، بما في ذلك <strong>الخدمات غير المصرّح بها</strong> صراحة من قبل الشركة.</p>
<p>لا تتحمل &quot;تمويل الأولى&quot; مسؤولية تجاه أي شخص عن أي <strong>تأخير، أو خسارة في الأعمال، أو الأرباح، أو الإيرادات، أو السمعة، أو المدخرات المتوقعة، أو الأضرار أو التكاليف أو الرسوم أو النفقات</strong> التي تنشأ بسبب:</p>
<ul>
<li>تعطل أو عدم توفر خدمات الموقع الرقمي&nbsp; </li>
<li>أو أي سبب آخر خارج عن إرادة الشركة</li>
</ul>
<p>يوافق العميل على:</p>
<ul>
<li><strong>تعويض &quot;تمويل الأولى&quot; والأطراف التابعة لها</strong> والدفاع عنهم ضد جميع المطالبات أو الخسائر أو الالتزامات أو التكاليف والنفقات،&nbsp; </li>
<li>بما في ذلك الرسوم القانونية، الناتجة عن أو المتعلقة باستخدام خدمات تطبيق &quot;تمويل الأولى&quot;،&nbsp; </li>
<li>أو أي <strong>خرق لهذه الشروط والأحكام</strong>، أو <strong>انتهاك للضمانات والتعهدات</strong> من قبل العميل.</li>
</ul>
<p>يحتوي الموقع الرقمي لشركة &quot;تمويل الأولى&quot; على <strong>روابط خارجية لمورّدين وأطراف ثالثة</strong>، تُعرض لتمكين العملاء من الوصول إلى منتجاتهم وخدماتهم.<br />مع ذلك، <strong>لا تتحمل &quot;تمويل الأولى&quot; أي مسؤولية عن ممارسات الخصوصية أو الأمان</strong> التي تتبعها تلك الأطراف، كما لا تمثل الشركة أي طرف ثالث أو مستخدم، حتى أثناء إجراء معاملة بينهما.</p>
<p>يُنصح العميل بمراجعة <strong>سياسات الخصوصية والأمان</strong> الخاصة بكل موقع خارجي يتم الدخول إليه عبر الروابط.</p>
<p>بمجرد انتقال العميل إلى موقع طرف ثالث، فإنه <strong>يخرج من نطاق الأمان والخصوصية</strong> الذي توفره &quot;تمويل الأولى&quot;، والشركة <strong>غير مسؤولة عن محتوى تلك المواقع أو تصرفات مالكيها</strong>.</p>
<p>&quot;تمويل الأولى&quot; <strong>هي المالكة الوحيدة</strong> لجميع <strong>حقوق النشر والتصميم والعرض</strong> المتعلقة بصفحات الموقع الرقمي ومحتواه، <strong>ما لم يُنص على خلاف ذلك</strong>.</p>
<p>&quot;تمويل الأولى&quot; <strong>ليست مسؤولة عن تأخير استلام السلع أو الخدمات</strong> التي تم طلبها من الموردين، كما أنها <strong>غير مسؤولة عن سياسات الإرجاع أو الاستبدال</strong> الخاصة بهم.</p>
<h3 id="-"><strong>توفر موقع الويب</strong></h3>
<p>تسعى شركة <strong>تمويل الأولى</strong> إلى الحفاظ على <strong>توفر الموقع الرقمي على مدار الساعة وطوال أيام الأسبوع</strong>، لضمان تقديم أفضل تجربة للمستخدم.<br />ومع ذلك، <strong>لا تتحمل الشركة أي مسؤولية</strong> عن <strong>أي توقف مؤقت أو دائم</strong> في الخدمة لأي سبب كان، أو لأي فترة زمنية، سواء كان ذلك نتيجة لأعمال صيانة، أو تحديثات تقنية، أو ظروف خارجة عن إرادة الشركة.</p>
<p><strong>طلب الدفع والتنفيذ</strong></p>
<p>في حال <strong>تخلّف العميل عن السداد</strong> أو <strong>إنهاء العلاقة التعاقدية</strong> لأي سبب من الأسباب، تحتفظ <strong>&quot;تمويل الأولى&quot;</strong> بالحق في اتخاذ كافة <strong>الإجراءات القانونية والتنفيذية اللازمة</strong>، وذلك <strong>وفقًا لما هو منصوص عليه في المادة الثامنة من عقد التمويل الاستهلاكي</strong> المبرم بين الطرفين، والتي تنظم أحكام:</p>
<p>📌 <strong>المادة الثامنة: التأخر أو التعثّر في السداد</strong></p>
<p>وتتضمن هذه المادة الحقوق والواجبات المتعلقة بالتأخير في سداد الأقساط، والإجراءات التي يمكن اتخاذها من قبل &quot;تمويل الأولى&quot;، بما يشمل – على سبيل المثال لا الحصر – إشعارات المطالبة، إدراج العميل في السجلات الائتمانية، أو اللجوء للجهات القضائية المختصة.</p>
<h3 id="-"><strong>الأخطاء والأعطال</strong></h3>
<p>في حال حدوث أي <strong>خطأ أو عطل تقني أو مالي</strong> يؤدي إلى تحصيل مبالغ غير مستحقة من العميل، تلتزم <strong>شركة &quot;تمويل الأولى&quot;</strong> بـ:</p>
<ul>
<li><strong>إعادة المبالغ المحصّلة بالخطأ</strong> إلى حساب المتضرر <strong>دون تأخير</strong>،&nbsp; </li>
<li>ودون الحاجة إلى تقديم <strong>مطالبة رسمية أو قانونية</strong> من العميل.</li>
</ul>
<p>ويتم ذلك فور التحقق من وجود الخطأ، حرصًا من الشركة على حفظ حقوق العملاء وضمان أعلى درجات الشفافية والنزاهة.</p>
<p><strong>وفاة العميل أو العجز الكلي</strong></p>
<p>في حال <strong>وفاة العميل</strong> أو تعرضه لـ <strong>عجز كلي دائم</strong>، يُعفى المستفيد من <strong>جميع الالتزامات المالية</strong> الناشئة بموجب <strong>عقد التمويل</strong> المبرم مع العميل، وذلك وفقًا <strong>لضوابط وإجراءات التحصيل للعملاء الأفراد</strong> المعتمدة.</p>
<p>ويُعتبر المستفيد في هذه الحالة قد <strong>أوفى بجميع التزاماته التعاقدية</strong> وفقًا لشروط العقد.</p>
<p>🔹<strong>استثناء:</strong><br />لا يُطبّق الإعفاء المشار إليه أعلاه إذا كانت <strong>الوفاة أو العجز مشمولة ضمن الاستثناءات المنصوص عليها</strong> في <strong>المادة (16)</strong> من <strong>عقد التمويل الاستهلاكي</strong>، أو في حال مخالفة الضوابط والتعليمات الخاصة الصادرة عن الجهات المختصة.</p>
<h3 id="-"><strong>الإشعارات والاتصالات</strong></h3>
<p>تُعد <strong>الإشعارات والمراسلات الرسمية</strong> جزءًا أساسيًا من أنظمة التواصل المعتمدة لدى &quot;تمويل الأولى&quot;.<br />ويُعتمد <strong>العنوان البريدي، والبريد الإلكتروني، ورقم الهاتف</strong> المُثبتة في <strong>عقد التمويل المبرم مع العميل</strong> كوسائل رسمية ونهائية لإرسال:</p>
<ul>
<li>الإشعارات&nbsp; </li>
<li>التنبيهات&nbsp; </li>
<li>الرسائل والمراسلات الأخرى</li>
</ul>
<p>📌 <strong>وفي حال حدوث أي تغيير في بيانات التواصل الخاصة بالعميل</strong>، يلتزم العميل بإبلاغ &quot;تمويل الأولى&quot; <strong>كتابيًا</strong> بالتغييرات الجديدة <strong>على الفور</strong>.</p>
<p>وفي حال عدم الإبلاغ، تُعتبر الإشعارات المُرسلة إلى البيانات المعتمدة في العقد صحيحة ومنتجة لآثارها القانونية.</p>
<h3 id="-"><strong>الدقة وحدود الضمان</strong></h3>
<p>تبذل <strong>&quot;تمويل الأولى&quot;</strong> أقصى جهد ممكن لضمان <strong>صحة ودقة</strong> جميع المعلومات والمحتويات المنشورة عبر منصاتها الرقمية.<br />ومع ذلك، لا تقدم الشركة <strong>أي ضمان صريح أو ضمني</strong> بشأن:</p>
<ul>
<li>دقة المعلومات&nbsp; </li>
<li>توقيتها&nbsp; </li>
<li>مدى اكتمالها أو حداثتها</li>
</ul>
<p>ويُقر العميل بأن جميع المعلومات المعروضة يتم تقديمها <strong>&quot;كما هي&quot;</strong> (As-Is) <strong>دون أي ضمانات أو شروط</strong> أو التزامات من أي نوع، سواء كانت صريحة أو ضمنية أو قانونية، بما في ذلك – على سبيل المثال لا الحصر – الضمانات المتعلقة بالملاءمة لغرض معين أو قابلية الاستخدام أو التوافق مع القوانين.</p>
<h3 id="-"><strong>تعريف المسؤولية</strong></h3>
<p>لا تتحمّل <strong>شركة &quot;تمويل الأولى&quot;</strong>، تحت أي ظرف من الظروف، <strong>أي مسؤولية قانونية</strong> عن أي أضرار أو خسائر أو نفقات، سواء كانت:</p>
<ul>
<li>مباشرة أو غير مباشرة&nbsp; </li>
<li>خاصة أو عرضية&nbsp; </li>
<li>أو مرتبطة أو ناتجة بأي شكل من الأشكال</li>
</ul>
<p>وذلك فيما يتعلق بـ:</p>
<ul>
<li>استخدام الموقع الرقمي أو عدم القدرة على استخدامه من قبل أي طرف&nbsp; </li>
<li>أو بسبب أي قصور في الأداء&nbsp; </li>
<li>أو خلل فني، أو انقطاع، أو تأخير تشغيلي أو تأخير في الإرسال&nbsp; </li>
<li>أو إصابة بفيروسات، أو فشل في النظام أو الاتصال</li>
</ul>
<p>وذلك حتى وإن تم إبلاغ &quot;تمويل الأولى&quot; أو ممثليها مسبقًا بإمكانية حدوث مثل هذه الأضرار أو الخسائر.</p>
<p>🛡️ <strong>جميع الحقوق محفوظة لشركة تمويل الأولى.</strong></p>
<h3 id="-"><strong>القانون الواجب التطبيق وتسوية المنازعات</strong></h3>
<p>تخضع <strong>جميع المنتجات والخدمات</strong> المقدمة من <strong>&quot;تمويل الأولى&quot;</strong>، بما في ذلك هذه <strong>الشروط والأحكام</strong>، وأي <strong>تعديلات أو إضافات أو تحديثات</strong> لاحقة، بالإضافة إلى جميع الشروط الخاصة المطبّقة على الخدمات المختلفة، إلى <strong>أنظمة وقوانين المملكة العربية السعودية</strong>.</p>
<p>وفي حال نشوء <strong>أي نزاع أو اختلاف</strong> بين &quot;تمويل الأولى&quot; وأي عميل، سواءً كان ذلك متعلقًا:</p>
<ul>
<li>بمعاملة مالية،&nbsp; </li>
<li>أو أي من المنتجات أو الخدمات،&nbsp; </li>
<li>أو بالشروط والأحكام العامة أو الخاصة المعتمدة من قبل الشركة،</li>
</ul>
<p>فسيتم <strong>إحالة النزاع إلى السلطة القضائية المختصة</strong> في المملكة العربية السعودية، والتي <strong>تختارها &quot;تمويل الأولى&quot;</strong> باعتبارها الجهة القضائية المناسبة للنظر في هذه المنازعات.</p>
<h3 id="-"><strong>موافقة العملاء</strong></h3>
<p>أُقر أنا الموقع أدناه بأن <strong>جميع البيانات والمعلومات</strong> الواردة في هذا الطلب <strong>صحيحة وكاملة وتحت مسؤوليتي الكاملة</strong>، وتُعد ملزمة لي، وتشكل جزءًا مكملًا لعقد التمويل أو أي مستند يتم توقيعه لاحقًا عند الموافقة النهائية من قبل شركة &quot;تمويل الأولى&quot;.</p>
<p>أُفوّض &quot;تمويل الأولى&quot; بحق <strong>الاتصال بي في أي وقت</strong>، وأوافق على استخدام <strong>التحليل التفاعلي عبر تطبيق &quot;تمويل الأولى&quot;</strong>، واستقبال <strong>الإشعارات الترويجية</strong>، بالإضافة إلى <strong>الإشعارات المتعلقة برحلة الطلب</strong> عبر الموقع الرقمي.</p>
<p>أوافق على تزويد الشركة <strong>بأي معلومات أو بيانات إضافية</strong> تطلبها مني لغرض:</p>
<ul>
<li>تأسيس الحساب&nbsp; </li>
<li>مراجعة الحساب&nbsp; </li>
<li>إدارة الحساب لدى الشركة</li>
</ul>
<p>كما أُفوّض &quot;تمويل الأولى&quot; بالحصول على أية معلومات تخصني من:</p>
<ul>
<li><strong>الشركة السعودية للمعلومات الائتمانية (سمة)</strong>&nbsp; </li>
<li>أو <strong>أي جهة حكومية أو تنظيمية</strong>&nbsp; </li>
<li>أو أي جهة أخرى معتمدة من <strong>البنك المركزي السعودي</strong></li>
</ul>
<p>ويشمل ذلك الإفصاح عن <strong>أي حساب حالي أو سابق</strong> باسمي لدى تلك الجهات، لصالح &quot;تمويل الأولى&quot; في إطار متطلبات تقديم الخدمة.</p>
<p>أُقر بأنني <strong>المستفيد الحقيقي من طلب التمويل</strong>، وأن هذا الطلب يُقدّم نيابة عني شخصيًا، ولا يمثل أي طرف آخر.</p>
<p>نبذة عن رسال :</p>
<p><strong>البيع بالتقسيط</strong></p>
<p>البيع بالتقسيط هو اتفاق يتم بين <strong>شركة &quot;تمويل الأولى&quot;</strong> و<strong>البائع</strong> من خلال <strong>عقد مبرم بين الطرفين</strong>، ويهدف إلى تمكين <strong>المشتري</strong> من شراء سلعة أو الحصول على خدمة <strong>بشكل فوري</strong>، مع سداد قيمتها على <strong>أقساط مالية متساوية</strong> خلال فترة زمنية محددة ومتفق عليها.</p>
<p>يوفّر هذا النظام <strong>مرونة مالية</strong> للمشتري، حيث يمكنه اقتناء السلع أو الخدمات التي يحتاجها <strong>دون الحاجة إلى دفع كامل المبلغ مقدمًا</strong>، مما يسهم في تسهيل إدارة المصروفات وتحقيق الاستفادة من المنتجات والخدمات بطريقة ميسّرة.</p>
<h3 id="-"><strong>إرسال وتفعيل الكوبون</strong></h3>
<p>يتم إصدار <strong>كوبونات الخصم أو العروض الترويجية</strong> عن طريق <strong>طرف ثالث</strong>، وتُرسل إلى العميل من خلال:</p>
<ul>
<li>البريد الإلكتروني&nbsp; </li>
<li>أو الرسائل النصية (SMS)</li>
</ul>
<p>ويخضع استخدام وتفعيل هذه الكوبونات إلى <strong>الشروط والأحكام المحددة من قبل الجهة المصدِرة</strong>، بما في ذلك <strong>آلية التفعيل</strong>، ومدة الصلاحية، وأي قيود أخرى ذات علاقة.</p>
<p>⚠️ &quot;تمويل الأولى&quot; <strong>غير مسؤولة</strong> عن أي تأخير أو خلل أو مشاكل تقنية تتعلق بإصدار أو تفعيل الكوبون من قبل الطرف الثالث.</p>
<h3 id="-"><strong>الشروط والأحكام العامة لخدمة تقسيط المشتريات</strong></h3>
<ol>
<li><strong>خدمة تقسيط المشتريات</strong> هي خدمة مقدّمة من <strong>شركة &quot;تمويل الأولى&quot;</strong>، وتحتفظ الشركة <strong>بالحق الكامل في قبول أو رفض</strong> أي طلب تمويل يُقدَّم من قبل العميل، وذلك بناءً على <strong>أهليته المالية</strong> و<strong>الشروط والأحكام المعتمدة</strong> لدى مزوّد الخدمة.&nbsp; </li>
<li>يُمكن للعميل الاستفادة من خدمة التقسيط شريطة أن تكون <strong>قيمة الفاتورة لا تقل عن 3,500 ريال سعودي</strong>، ولا تتجاوز <strong>500,000 ريال سعودي</strong>.&nbsp; </li>
<li><strong>سياسات الاستبدال والاسترجاع</strong> تخضع بالكامل إلى <strong>سياسات التاجر</strong> الذي تم الشراء منه، ولا تتحمّل &quot;تمويل الأولى&quot; أي مسؤولية تجاه هذه الإجراءات.&nbsp; </li>
<li><strong>سياسة دمج الدفع</strong> (مثل دمج عدة طلبات أو دفعات) تخضع أيضًا إلى <strong>سياسة التاجر</strong> المعني.&nbsp; </li>
<li><strong>الموافقة الائتمانية</strong> التي تصدر للعميل صالحة لمدة <strong>3 أيام تقويمية فقط</strong> من تاريخ صدورها، ويتعيّن على العميل إتمام الإجراءات خلالها لتفعيل الطلب.&nbsp; </li>
<li>للمزيد من التفاصيل أو الاستفسارات، يُرجى التواصل معنا عبر <strong>الرقم الموحد</strong> أو القنوات الرسمية الخاصة بـ &quot;تمويل الأولى&quot;</li>
</ol>
`;

    const showTermsModal = () => {
        setIsTermsModalVisible(true);
    };

    const handleTermsOk = () => {
        setIsTermsModalVisible(false);
    };

    const handleTermsCancel = () => {
        setIsTermsModalVisible(false);
    };
    // const { values } = useFormikContext()

    const isArabic = language?.code === "ar" ? true : false;

    let isLoading = createNewAppStatus.isLoading || updateAppDetailsStatus.isLoading;
    const sheriZeroSchema = ({ hideRequestedLoanAmount = true, tenureOptions = [] }) => [
        {
            type: "number",
            key: "request_amount",
            label: "Requested_loan_amount",
            span: 24,
            required: !hideRequestedLoanAmount,
            disabled: hideRequestedLoanAmount,
            pattern: "^[0-9]*$",
            validation: Yup.number()
                .required("CANNOT_BE_EMPTY")
                .min(5000, "MUST_BE_ATLEAST_5000")
                .max(30000, "CANNOT_EXCEED_30000")
        },
        {
            type: "select",
            key: "tenure",
            label: "Tenure",
            required: true,
            options: tenureOptions,
            span: 24,
            validation: Yup.string()
                .required("CANNOT_BE_EMPTY")
        },
        {
            type: "number",
            key: "salesRef",
            label: "SalesRef",
            span: 24,
            required: false,
            max: 10,
            min: 8,
            maxLength: 10,
            minLength: 8,
            validation: Yup.string()
                .matches(/^\d{8,10}$/, "MUST_BE_BETWEEN_8_AND_10_DIGITS")
        },
    ];

    const sheriSchema = ({ hideRequestedLoanAmount = true, tenureOptions = [] }) => [
        {
            type: "number",
            key: "request_amount",
            label: "Requested_loan_amount",
            span: 24,
            required: !hideRequestedLoanAmount,
            disabled: hideRequestedLoanAmount,
            pattern: "^[0-9]*$",
            validation: Yup.number()
                .required("CANNOT_BE_EMPTY")
                .min(3500, "MUST_BE_ATLEAST_3500")
                .max(500000, "CANNOT_EXCEED_500000")
        },
        {
            type: "select",
            key: "tenure",
            label: "Tenure",
            required: true,
            options: tenureOptions,
            span: 24,
            validation: Yup.string()
                .required("CANNOT_BE_EMPTY")
        },
        {
            type: "number",
            key: "salesRef",
            label: "SalesRef",
            span: 24,
            required: false,
            max: 10,
            min: 8,
            maxLength: 10,
            minLength: 8,
            validation: Yup.string()
                .matches(/^\d{8,10}$/, "MUST_BE_BETWEEN_8_AND_10_DIGITS")
        },
    ]; const TenureUpdater = (props) => {
        const tenureOpt = useMemo(() => {
            const amount = props.values?.request_amount;

            // For SheriZero (id === "1"), always show 4, 6, 12 months regardless of amount
            if (id === "1") {
                return [
                    { value: '4', label: '4' },
                    { value: '6', label: '6' },
                    { value: '12', label: '12' }
                ];
            }
            else if (id === "2") {
                return [
                    { value: '13', label: '13' },
                    { value: '18', label: '18' },
                    { value: '24', label: '24' },
                    { value: '30', label: '30' },
                    { value: '36', label: '36' },
                    { value: '42', label: '42' },
                    { value: '48', label: '48' },
                    { value: '54', label: '54' },
                    { value: '60', label: '60' }
                ];
            }


            // // For Sheri (id === "2"), use the existing logic
            // if (amount <= 10000 && amount >= 5000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }];
            // if (amount >= 10001 && amount <= 25000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }, { value: '24', label: '24' }, { value: '36', label: '36' }];
            // if (amount >= 25001 && amount <= 500000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }, { value: '24', label: '24' }, { value: '36', label: '36' }, { value: '48', label: '48' }, { value: '60', label: '60' }];

            return [];
        }, [props.values?.request_amount]);

        let tenureSelectionCheck = tenureOpt.find(opt => opt.value === props.values?.tenure)
        if (tenureSelectionCheck === undefined && props.values?.tenure !== "") {
            props.setValues((prev) => ({
                ...prev,
                tenure: ""
            }))
        }

        setTenureOptions(tenureOpt);

        return null; // This component doesn't render anything directly
    };

    // V2 Submit function - only needs applicationId
    const voucherAppSubmitV2 = async (applicationId) => {
        try {
            console.log('> Submitting voucher application V2:', applicationId);

            const response = await updateApplicationDetailsV2({
                applicationId: applicationId
            });

            if (response.error) {
                console.error('> Error submitting voucher application:', response.error);
                toast.error("Error in submitting application");
                setIsCreating(false);
                return false;
            }

            if (response.data) {
                console.log('> Voucher application submitted successfully');
                toast.success("Application Created Successfully");
                setIsCreating(false);
                navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${applicationId}/1`, { replace: true });
                return true;
            }
        } catch (error) {
            console.error('> Exception in voucherAppSubmitV2:', error);
            toast.error("Error in submitting application");
            setIsCreating(false);
            return false;
        }
    };

    // ========== V1 FUNCTIONS (KEPT FOR BACKWARDS COMPATIBILITY) ==========
    const VoucherAppSubmitV1 = async (values, appId, idbUserId) => {
        values.productId = '330' //murhaba
        values.subproductId = id === "1" ? '371' : '373' //sheriZero or sheri
        values.applStatus = 'S' //submitted

        const response = await updateApplicationDetails({
            appId: appId,
            userWebId: idbUserId,
            source: 'WEB',
            details: values,
        });
        if (response.error) {
            console.log("Error in update application", response.error);
            toast.error("Error in creating application");
            setIsCreating(false);
            return
        }
        if (response.data) {
            toast.success("Application Created Successfully");
            setIsCreating(false);
            navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${appId}/1`, { replace: true });
        }
    }

    const VoucherAppCreateV1 = async (values) => {
        try {
            setIsCreating(true);
            const user = getUser();

            if (!user) {
                setIsCreating(false);
                return;
            }

            const res = await createNewApp({
                id: String(user?.IDB_USR_ID),
                idNumber: String(user?.USER_ID),
                idType: String(user?.USER_ID)[0] === "1" ? "NID" : "Q",
            }).unwrap();
            if (res?.query) {
                handleUploadDocumentsV1(fileList, res?.query);
                await VoucherAppSubmitV1(values, res?.query, String(user?.IDB_USR_ID));
            } else {
                setIsCreating(false);
            }
        } catch (ex) {
            console.log("Error in create application", ex);
            const errorCode = ex?.data?.error?.code;
            if (errorCode === 'ACTIVE_APPLICATION' || errorCode === 'APPLICATION_EXISTS') {
                toast.error(translate('ACTIVE_APPLICATION'));
            } else {
                toast.error(ex?.data?.error?.message || "Error in creating application");
            }
            setIsCreating(false);
        }
    }

    const handleUploadDocumentsV1 = async (files, appId) => {
        setIsUploading(true);
        let updatedDocumentDetails = [...files];
        let allSuccess = true;
        try {
            await Promise.all(
                fileList.map(async (file, index) => {
                    const formData = new FormData();
                    formData.append("document", file);
                    formData.append("appId", appId);
                    const data = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));

                    try {
                        await axios.post(`${env.API_ENDPOINT}app/upload-document`, formData, {
                            headers: {
                                Authorization: `Bearer ${data.token}`,
                            },
                        });
                        updatedDocumentDetails.splice(index, 1);
                    } catch (err) {
                        allSuccess = false;
                        toast.error("Failed to upload file.");
                    }
                })
            );
        } catch (error) {
            allSuccess = false;
            console.error("Document upload error:", error);
            toast.error("Failed to upload documents.");
            setIsCreating(false);
        } finally {
            setIsUploading(false);
        }
    }

    // ========== V2 FUNCTIONS (ACTIVE) ==========
    const VoucherAppCreateV2 = async (values) => {
        try {
            setIsCreating(true);
            const user = getUser();

            if (!user) {
                setIsCreating(false);
                return;
            }

            console.log('> Creating voucher application V2 with values:', values);

            // Determine productSubType based on voucher type (id from URL params)
            const productSubType = id === "1" ? "SHAREEZERO" : "SHAREE";

            // Step 1: Create application via V2 API
            const res = await createNewMurabahaApp({
                productRef: "SMB.TA.MURABAHA.FINANCE",
                productGroupRef: "SMB.TA.MURABAHA.FINANCE",
                productName: "MUR",
                productSubType: productSubType,
                idType: String(user?.USER_ID)[0] === "1" ? "NATIONAL.ID" : "IQAMA.ID",
                idNumber: String(user?.USER_ID),
                userWebId: Number(user?.IDB_USR_ID),
                source: "Web",
                details: {
                    request_amount: values.request_amount,
                    tenure: values.tenure,
                    salesRef: values.salesRef || null,
                    dealerId: id == '2' ? '100888' : '101114', //sheri dealer id only for now
                }
            }).unwrap();

            if (res?.data?.applicationId) {
                const appId = res.data.applicationId;
                console.log('> Voucher application created with ID:', appId);

                // Step 2: Upload documents
                await uploadV2Documents(appId);

                // Step 3: Show IVR verification modal instead of submitting
                setIvrApplicationId(appId);
                setIsIvrModalVisible(true);
                setIsCreating(false);
            } else {
                toast.error("Failed to create application");
                setIsCreating(false);
            }
        } catch (ex) {
            console.error("Error in create voucher application:", ex);
            const errorCode = ex?.data?.error?.code;
            if (errorCode === 'ACTIVE_APPLICATION' || errorCode === 'APPLICATION_EXISTS') {
                toast.error(translate('ACTIVE_APPLICATION'));
            } else {
                toast.error(ex?.data?.error?.message || "Error in creating application");
            }
            setIsCreating(false);
        }
    };

    // V2 Document upload function
    const uploadV2Documents = async (appId) => {
        if (!fileList || fileList.length === 0) {
            console.log('> No documents to upload');
            return;
        }

        console.log('> Uploading documents for voucher app:', appId);
        setIsUploading(true);

        try {
            await Promise.all(
                fileList.map(async (file) => {
                    return uploadSingleDocument(file, 'OTHERS', appId);
                })
            );
            console.log('> All voucher documents uploaded successfully');
        } catch (error) {
            console.error('> Error uploading voucher documents:', error);
            toast.error("Some documents failed to upload");
        } finally {
            setIsUploading(false);
        }
    };

    // Helper function to upload a single document
    const uploadSingleDocument = async (file, documentType, appId) => {
        const formData = new FormData();
        formData.append("document", file.originFileObj || file);
        formData.append("appId", appId);
        formData.append("docType", documentType);

        const data = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));

        try {
            await axios.post(`${env.API_ENDPOINT_V2}app/upload-document`, formData, {
                headers: {
                    Authorization: `Bearer ${data.token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log(`> Document uploaded successfully: ${file.name}`);
            return true;
        } catch (err) {
            console.error(`> Failed to upload document: ${file.name}`, err);
            throw err;
        }
    };

    const beforeUpload = (file) => {
        const isJpgOrPngOrPdf =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "application/pdf";
        if (!isJpgOrPngOrPdf) {
            toast.error(translate("SETTINGS.ERROR_FILE_TYPE"));
            return true;
        }

        console.log('file size', file.size, file.size / 1024 / 1024)
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isLt3M) {
            toast.error(translate("SETTINGS.ERROR_FILE_SIZE_3MB"));
            return true;
        }

        const fileName = file.name;
        const multipleExtensionsPattern = /(\.[^.\s]{2,4}){2,}$/;
        if (multipleExtensionsPattern.test(fileName)) {
            toast.error(translate("SETTINGS.ERROR_FILE_MULTIPLE_EXT"));
            return true;
        }
        const invalidFileNamePattern = /^[^.]+\.[^.]+\..+\.[^.]+$/;

        if (invalidFileNamePattern.test(fileName)) {
            toast.error(translate("SETTINGS.ERROR_FILE_MULTIPLE_EXT"));
            return true;
        }

        if (fileName.toLowerCase().includes('contract')) {
            toast.error(translate("SETTINGS.ERROR_FILE_NAME_CONTRACT"));
            return true
        }
        setUploadFile(file)
        return false;
    };

    const validateFile = (file) => {
        // Check for duplicate files first
        if (isDuplicateFileName(file.name)) {
            toast.error(
                `${translate("SETTINGS.ERROR_FILE_DUPLICATE")} / لقد تم تحديد هذا الملف بالفعل`
            );
            return false;
        }

        const isValidType =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "application/pdf";

        if (!isValidType) {
            return false;
        }

        const isUnder3MB = file.size / 1024 / 1024 < 3;
        if (!isUnder3MB) {
            return false;
        }

        const fileName = file.name;
        const multipleExtensionsPattern = /(\.[^.\s]{2,4}){2,}$/;
        if (multipleExtensionsPattern.test(fileName)) {
            return false;
        }

        const invalidFileNamePattern = /^[^.]+\.[^.]+\..+\.[^.]+$/;
        if (invalidFileNamePattern.test(fileName)) {
            return false;
        }

        if (fileName.toLowerCase().includes("contract")) {
            return false;
        }

        return true; // File is valid
    };

    // Check if any individual upload is in progress
    const isAnyFileUploading = bankStatementUploading || paySlipUploading || otherDocumentsUploading;

    // Helper function to check for duplicate filenames
    const isDuplicateFileName = (fileName) => {
        const existingFiles = [
            selectedBankStatement,
            selectedPaySlip,
            selectedOtherDocuments
        ].filter(file => file !== null);

        return existingFiles.some(file => file.name === fileName);
    };

    // V2 Document selection component (before app creation)
    const V2DocumentSelectionComponent = ({ title, file, onSelect, onRemove }) => {
        const handleFileSelect = (info) => {
            const selectedFile = info.file;
            if (validateFile(selectedFile)) {
                onSelect(selectedFile);
            }
        };

        const uploadProps = {
            name: 'file',
            multiple: false,
            accept: "application/pdf",
            beforeUpload: () => false, // Prevent automatic upload
            onChange: handleFileSelect,
            showUploadList: false
        };

        return (
            <div className="border border-gray-200 border-dashed rounded-lg p-4 mb-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center">
                            <UploadOutlined className="text-teal-600" />
                        </div>
                        <div>
                            <p className="font-medium text-gray-700">{translate(`CREATE_REQUEST.${title}`)}</p>
                            {file && (
                                <p className="text-sm text-gray-500">{file.name}</p>
                            )}
                        </div>
                    </div>

                    <div className="flex items-center gap-2">
                        {file ? (
                            <Button
                                onClick={onRemove}
                                className="text-red-500 border-red-500 hover:bg-red-50"
                                size="small"
                                icon={<DeleteOutlined />}
                            >
                                {translate("CREATE_REQUEST.REMOVE")}
                            </Button>
                        ) : (
                            <Upload {...uploadProps}>
                                <Button
                                    type="primary"
                                    className="bg-primary border-primary hover:bg-primary-dark"
                                >
                                    {translate("CREATE_REQUEST.SELECT_FILE")}
                                </Button>
                            </Upload>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const dragAndDropProps = {
        name: 'file',
        multiple: true,
        maxCount: 3,
        accept: "image/png,image/jpeg,image/jpg,application/pdf",
        beforeUpload,
        fileList,
        onChange(info) {
            if (info.file.status === 'error' || info.file.status === 'removed') {
                setFileList(prev => prev.filter(i => i.uid !== info.file.uid))
                return
            }
            const isValid = validateFile(info.file);
            if (isValid) {
                setFileList([...fileList, info.file])
                // dispatch({ type: PATCH_DOCUMENT_DETAILS, payload: [...fileList, info.file] });
            }
        },
        onDrop(e) {
            setFileList([e.dataTransfer.files])
        },
    }; const handleRemove = (e) => {
        let updateFiles = fileList.filter(i => i.uid !== e.uid)
        // console.log('hi', updateFiles)
        // dispatch({ type: PATCH_DOCUMENT_DETAILS, payload: updateFiles });
        setFileList(prev => prev.filter(i => i.uid !== e.uid));
        setUploadFile(null)
    };

    const schemaFields = useMemo(
        () => {
            let hideRequestedLoanAmount = false;

            if (id === "1") {
                // SheriZero schema
                return sheriZeroSchema({
                    hideRequestedLoanAmount: hideRequestedLoanAmount,
                    tenureOptions
                })
            } else {
                // Sheri schema
                return sheriSchema({
                    hideRequestedLoanAmount: hideRequestedLoanAmount,
                    tenureOptions
                })
            }
        },
        [tenureOptions]
    );

    const sheriCards = () => {
        return (
            <div
                className="w-full max-w-[385px] max-h[300px] overflow-hidden"
            >
                <img src={id == "1" ? SheriZeroCard : SheriCard} alt="sheri" className="align-middle" />

            </div>
        )
    }

    const sheriZeroCardDetails = () => {
        return (
            <Card
                bordered={false}
                className="bg-transparent shadow-none rounded-none border-none outline-none"
                style={{
                    width: '100%',
                    maxWidth: "550px",
                    minHeight: "250px", boxShadow: "none", // Remove shadow
                    border: "none",    // Remove border
                    borderRadius: "0", // Remove border-radius
                    outline: "none",
                    // direction: 'ltr'

                }}
            >
                <ul className="mt-3">
                    {[
                        translate('VOUCHERS.SHERIZERO_PT1'),
                        <>
                            {translate('VOUCHERS.SHERIZERO_PT2')}{""}
                            <Link
                                to={appRoute(routes.MERCHANTS.SHERIZERO)}
                                className="text-emerald-700 font-semibold underline ml-1 mr-1"
                            >
                                {translate('VOUCHERS.EIGHTY_FIVE_MERCHANTS')}
                            </Link>
                        </>,
                        <li className="flex items-center" key="riyal-price"> {/* Added flex and items-center to this li */}
                            {isArabic ?
                                <span className="break-words">
                                    <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate("VOUCHERS.STARTS_FROM")} {translate('VOUCHERS.FIVE_THOUSAND')}
                                </span>
                                :
                                <span className="break-words">
                                    {translate("VOUCHERS.STARTS_FROM")} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate('VOUCHERS.FIVE_THOUSAND')}
                                </span>}
                        </li>,
                        translate("VOUCHERS.SHERIZERO_PT4"),
                    ].map((text, index) => (
                        <li className="flex mb-4 gap-2" key={index}>
                            <span className="flex-shrink-0">
                                <img src={Arrow} alt="checkmark" className="w-6 h-6" />
                            </span>
                            <span className="text-sm break-words">{text}</span>
                        </li>
                    ))}
                </ul>
                {/* <Button onClick={() => handleClick('1')} className="mt-4 bg-secondary border-none text-black font-semibold hover:!text-white hover:!bg-primary">
                    Select
                </Button> */}
                {/* <div className="mt-4">
                    <label className="flex items-center gap-2">
                        <input
                            type="checkbox"
                            className="form-checkbox border border-gray-400 w-10"
                            checked={termsChecked}
                            onChange={(e) => setTermsChecked(e.target.checked)}
                        />
                        <span className="text-gray-700 text-xs">{translate("TERMS_AND_CONDITIONS")}</span>
                    </label>
                </div> */}
            </Card >
        )
    }

    const sheriCardDetails = () => {
        return (
            <Card
                bordered={false}
                className="bg-transparent shadow-none rounded-none border-none outline-none"
                style={{
                    borderWidth: 1,
                    borderColor: "black",
                    width: '100%',
                    maxWidth: "550px",
                    minHeight: "250px", boxShadow: "none", // Remove shadow
                    border: "none",    // Remove border
                    borderRadius: "0", // Remove border-radius
                    outline: "none",
                    // direction:'ltr'
                }}
            >

                <ul className="mt-3">
                    {[
                        translate("VOUCHERS.SHERI_PT1"),
                        <>
                            {translate('VOUCHERS.SHERIZERO_PT2')}{""}
                            <Link
                                to={appRoute(routes.MERCHANTS.SHERI)}
                                className="text-emerald-700 font-semibold underline ml-1 mr-1"
                            >
                                {translate('VOUCHERS.FOUR_HUNDRED_MERCHANTS')}
                            </Link>
                        </>,
                        <li className="flex items-center" key="riyal-price"> {/* Added flex and items-center to this li */}
                            {isArabic ?
                                <span className="break-words">
                                    {translate("VOUCHERS.MAX_LIMIT")} {translate('VOUCHERS.FIVE_HUNDRED_THOUSAND')} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" />
                                </span> :
                                <span className="break-words">
                                    {translate("VOUCHERS.MAX_LIMIT")} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate('VOUCHERS.FIVE_HUNDRED_THOUSAND')}
                                </span>
                            }
                        </li>,
                        translate('VOUCHERS.SHERI_PT2'),
                    ].map((text, index) => (
                        <li className="flex gap-2 mb-4" key={index}>
                            <span className="flex-shrink-0">
                                <img src={Arrow} alt="checkmark" className="w-6 h-6" />
                            </span>
                            <span className="text-sm break-words">{text}</span>
                        </li>
                    ))}
                </ul>
                {/* <Button onClick={() => handleClick('2')} className="mt-4 bg-secondary border-none text-black font-semibold hover:!text-white hover:!bg-primary">
                    Select
                </Button> */}
                {/* <div className="mt-6">
                    <label className="flex items-center gap-2 mt-2">
                        <input
                            type="checkbox"
                            className="form-checkbox border border-gray-400 w-5 h-5 rounded-full"
                            checked={termsChecked}
                            onChange={(e) => setTermsChecked(e.target.checked)}
                        />
                        <span className="text-gray-700 text-sm">{translate("TERMS_AND_CONDITIONS")}</span>
                    </label>
                </div> */}
            </Card>
        )
    }

    return (
        <div className="rounded-xl mb-4 px-4 py-4 bg-white shadow-lg">
            <SalaryEligibilityGate productCode="MUR" />
            <div className="p-5">
                {/* <Button onClick={() => navigate(-1)}>{translate("Back")}</Button> */}
                <BackButton onClick={() => navigate(-1)} />

                <Row gutter={[16, 16]} className="pt-4">
                    {/* Card Section */}
                    <Col xs={24} md={10}>
                        {sheriCards()}
                        {id === "1" ? sheriZeroCardDetails() : sheriCardDetails()}
                    </Col>

                    {/* Form Section */}
                    <Col xs={24} md={14}>
                        <Formik
                            innerRef={formikRef}
                            validateOnChange={true}
                            validateOnMount={true}
                            initialValues={buildInitialValues(schemaFields)}
                            validationSchema={buildValidationSchema(schemaFields)}
                            onSubmit={(values) => VoucherAppCreateV2(values)}
                        >
                            {(props) => (
                                <Form onFinish={() => props.handleSubmit()}>
                                    {TenureUpdater(props)}
                                    <Title level={5} style={{ color: '#030438' }}>
                                        {translate('VOUCHERS.FILL_FORM')}
                                    </Title>
                                    <div>
                                        <FormDrawer schema={{ fields: schemaFields }} />
                                    </div>
                                    <div className="my-4">
                                        <label className="block text-gray-600 font-medium mb-2">
                                            {translate("SETTINGS.DOCUMENT_DES_V2")}
                                        </label>

                                        <V2DocumentSelectionComponent
                                            title="BANK_STATEMENT"
                                            file={selectedBankStatement}
                                            onSelect={setSelectedBankStatement}
                                            onRemove={() => setSelectedBankStatement(null)}
                                        />

                                        <V2DocumentSelectionComponent
                                            title="PAY_SLIP"
                                            file={selectedPaySlip}
                                            onSelect={setSelectedPaySlip}
                                            onRemove={() => setSelectedPaySlip(null)}
                                        />

                                        <V2DocumentSelectionComponent
                                            title="OTHER_DOCUMENTS"
                                            file={selectedOtherDocuments}
                                            onSelect={setSelectedOtherDocuments}
                                            onRemove={() => setSelectedOtherDocuments(null)}
                                        />
                                    </div>
                                    <div className="mt-6">
                                        <label className="flex items-center gap-2 mt-2">
                                            <input
                                                type="checkbox"
                                                className="form-checkbox border border-gray-400 w-5 h-5 rounded-full accent-primary"
                                                checked={termsChecked}
                                                onChange={(e) => setTermsChecked(e.target.checked)}
                                            />
                                            <Link onClick={showTermsModal} className="text-blue-950 text-sm underline">{translate("TERMS_AND_CONDITIONS")}</Link>
                                        </label>
                                    </div>                                    <div className="flex justify-end mt-8">

                                        <Button
                                            disabled={!props.isValid || !termsChecked || isCreating || isLoading || isAnyFileUploading}
                                            type="primary"
                                            htmlType="submit"
                                            className="mt-4 bg-primary border-none text-white font-semibold p-6 w-40"
                                        >
                                            {(isLoading || isAnyFileUploading || isCreating) ? <LoadingOutlined /> :
                                                translate("APPLY")}
                                        </Button>

                                    </div>

                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </div>
            <Modal
                title={translate("TERMS_AND_CONDITIONS")}
                open={isTermsModalVisible}
                onOk={handleTermsOk}
                onCancel={handleTermsCancel}
                width={'50%'}
                // height={'50%'}
                centered
                okText={translate("CLOSE")}
                okButtonProps={{ className: "bg-primary text-white" }}
                className="w-full"
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <div style={{
                    whiteSpace: "pre-line", textAlign: "right", maxHeight: '500px', // Adjust this value as needed
                    overflowY: 'auto',
                }}>
                    <div dangerouslySetInnerHTML={{ __html: jsxCompatibleHtmlString }} style={{ direction: 'rtl' }}></div>
                </div>
            </Modal>

            {/* IVR Verification Modal */}
            <Modal
                open={isIvrModalVisible}
                footer={null}
                closable={true}
                closeIcon={<CloseOutlined style={{ fontSize: '18px', color: '#000' }} />}
                onCancel={() => {
                    setIsIvrModalVisible(false);
                    // Navigate to success page when modal is closed
                    if (ivrApplicationId) {
                        navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${ivrApplicationId}/2`, { replace: true });
                    }
                }}
                centered
                width={500}
                bodyStyle={{ padding: '40px' }}
            >
                <div className="flex flex-col items-center text-center">
                    <img src={ivrPending} alt="IVR Verification" className="w-64 h-64 mb-6" />
                    <h2 className="text-2xl font-semibold mb-4 text-gray-800">
                        {translate("CREATE_REQUEST.IVR_VERIFICATION_TITLE")}
                    </h2>
                    <p className="text-gray-600 text-base leading-relaxed">
                        {translate("CREATE_REQUEST.IVR_VERIFICATION_MESSAGE")}
                    </p>
                    <Button
                        type="primary"
                        className="mt-6 bg-primary border-none text-white font-semibold px-16 py-5 rounded-3xl hover:bg-secondary"
                        onClick={() => {
                            setIsIvrModalVisible(false);
                            // Navigate to success page when button is clicked
                            if (ivrApplicationId) {
                                navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${ivrApplicationId}/2`, { replace: true });
                            }
                        }}
                    >
                        {translate("CREATE_REQUEST.CONTINUE")}
                    </Button>
                </div>
            </Modal>
        </div>

    )
}

export default Vouchers;